import $ from "jquery";

export function initImageDiff() {
  $(".image-diff").each(function() {
    const $container = $(this);

    // Before and After images
    const images = [
      {
        loaded: false,
        $elem: $container.find("img.image-before")
      },
      {
        loaded: false,
        $elem: $container.find("img.image-after")
      }
    ];

    for (const image of images) {
      // If no image (because of add or remove) => don't wait for load
      // Or if image is already loaded (no lazy load) => set to loaded
      if (!image.$elem.length || image.$elem[0].complete) {
        image.loaded = true;
        checkBothLoaded();
        continue;
      }

      image.$elem.on("load", function() {
        image.loaded = true;
        checkBothLoaded();
      });
    }

    function checkBothLoaded() {
      if (images[0].loaded && images[1].loaded) {
        initWidthHeightDiff(images[0].$elem[0], images[1].$elem[0]);
      }
    }

    function initWidthHeightDiff(beforeImgEl, afterImgEl) {
      const added = !beforeImgEl && afterImgEl;
      const removed = beforeImgEl && !afterImgEl;

      const beforeBlobSizeEl = $container.find(".info-before .size");
      const afterBlobSizeEl = $container.find(".info-after .size");

      let widthChanged = false;
      let heightChanged = false;
      let blobSizeChanged = false;

      if (!added && !removed) {
        widthChanged = beforeImgEl.naturalWidth !== afterImgEl.naturalWidth;
        heightChanged = beforeImgEl.naturalHeight !== afterImgEl.naturalHeight;
        blobSizeChanged = beforeBlobSizeEl.text() !== afterBlobSizeEl.text();
      }

      if (beforeImgEl) {
        $container
          .find(".info-before .width")
          .text(`${beforeImgEl.naturalWidth}px`)
          .addClass(widthChanged || removed ? "red" : "");

        $container
          .find(".info-before .height")
          .text(`${beforeImgEl.naturalHeight}px`)
          .addClass(heightChanged || removed ? "red" : "");

        beforeBlobSizeEl.addClass(blobSizeChanged || removed ? "red" : "");
      }

      if (afterImgEl) {
        $container
          .find(".info-after .width")
          .text(`${afterImgEl.naturalWidth}px`)
          .addClass(widthChanged || added ? "green" : "");

        $container
          .find(".info-after .height")
          .text(`${afterImgEl.naturalHeight}px`)
          .addClass(heightChanged || added ? "green" : "");

        afterBlobSizeEl.addClass(blobSizeChanged || added ? "green" : "");
      }
    }
  });
}
